"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToHsl = void 0;
var hex_to_rgb_1 = require("./hex-to-rgb");
var rgb_to_hsl_1 = require("./rgb-to-hsl");
var hexToHsl = function (hex) { return (0, rgb_to_hsl_1.rgbToHsl)((0, hex_to_rgb_1.hexToRgb)(hex)); };
exports.hexToHsl = hexToHsl;
